import { Controller } from "@hotwired/stimulus"

// Submits the filter form as soon as a select changes, so choosing a country or
// a salary band behaves like the facet links beside it, one interaction, not
// two.
//
// The form works without this. It is a real GET form with a submit button, so
// with JavaScript unavailable the filters still apply; this only removes the
// extra click.
//
// The fallback button is hidden by CSS on `[data-js]`, set by `document_scripted.js`
// from the layout's head before the first paint. Hiding it here instead ran a frame late
// and shifted everything beside it on every page load. `disconnect` still
// restores it, so a disconnected controller leaves a working form behind.
export default class extends Controller {
  static targets = ["submit"]
  static values = { submitInDialog: Boolean }

  disconnect() {
    this.submitTargets.forEach((button) => (button.hidden = false))
  }

  // Inside the board's mobile overlay this stays quiet. Auto-submitting there
  // navigates the page out from under an open <dialog> on the first change, so
  // the second filter is never chosen and the footer's "Show N roles" is never
  // reached. In the overlay the footer button is the submit, and it is a real
  // one.
  //
  // A dialog with no such button opts back in with `submit-in-dialog`: the
  // layoff tracker's filters are one choice each (a region discards the
  // country by design), so a change applies at once, as it did on the rail.
  //
  // The search field is left alone too: `change` fires when it loses focus and
  // again on Enter, and Enter already submits the form on its own.
  submit(event) {
    if (this.element.closest("dialog") && !this.submitInDialogValue) return
    if (event && event.target.type === "search") return

    this.element.requestSubmit()
  }
}
